import { render, staticRenderFns } from "./add-payment-record.vue?vue&type=template&id=a4896270&scoped=true&"
import script from "./add-payment-record.vue?vue&type=script&lang=js&"
export * from "./add-payment-record.vue?vue&type=script&lang=js&"
import style0 from "./add-payment-record.vue?vue&type=style&index=0&id=a4896270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4896270",
  null
  
)

export default component.exports